import { useState, useEffect } from 'react';
import type { Model } from '../types';
import { fetchModels } from '../api';

interface UseModelsOptions {
  apiUrl: string;
  apiKey?: string;
}

export function useModels({ apiUrl, apiKey }: UseModelsOptions) {
  const [models, setModels] = useState<Model[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!apiUrl) {
      setIsLoading(false);
      setError('API URL not configured');
      return;
    }

    const loadModels = async () => {
      try {
        setIsLoading(true);
        const data = await fetchModels({ apiUrl, apiKey });
        setModels(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching models:', err);
        setError(err instanceof Error ? err.message : 'Failed to load models');
        setModels([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadModels();
  }, [apiUrl, apiKey]);

  return { models, isLoading, error };
}
